import { DecimalPipe } from '@angular/common';
import { EventEmitter, Pipe, PipeTransform } from '@angular/core';
import { Output } from '@angular/core';
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subscription } from 'rxjs';
import { BObjectModel, BObjectSummary, ComboProperty, HtmlBase, QResult, QueovalDate, QueovalDik, Select, SendMailModel } from '../../../../../models';
import { TacheParam, TacheStage } from '../../../../../models/formation/formation.model';

import { CoreService, HttpService, QueovalDateService } from '../../../../../services';
import { ToastService } from '../../../../../toast';
import { isEmptyStr } from '../../../../../utilities';
import { StageService } from '../../services/stage-modal.service';



@Component({
  selector: 'queoval-stage-tache-tableau',
  templateUrl: './tacheTableau.component.html',
  styleUrls: ['./tacheTableau.component.css']
})
/*
* Composant pour l'affichage du tableau de taches
*/
export class TacheTableauComponent implements OnInit {

  // #region CONSTRUCTEUR
  constructor(
    public service: StageService,
    private http: HttpService,
    private indParam: CoreService,
    private toast: ToastService,
    public qDateService: QueovalDateService,
    private modalService: NgbModal
  ) {}
  // #endregion

  // #region VARIABLES GLOBALES

  
  /** model pour parametrage des taches auto*/
  public taskParam: TacheParam = new TacheParam();
  /** model pour creer une tache*/
  public taskToAdd: TacheStage = new TacheStage();
  /** model pour remettre les anciennes valeurs d'une tache en mode edit*/
  public oldTask: TacheStage;
  /** model pour modifier une tache (mode edit)*/
  public editTask: TacheStage;
  /** boolean pour cacher les autres boutons en mode edit*/
  public hideButton: boolean;
  /** booleens pour savoir si les dates de début et de fin sont cohérentes*/
  public isDateDebut: boolean;
  public isDateFin: boolean;
  /** duree total des taches du stage*/
  public totalTempsStage: number;
  /** nombre total de taches dans le cursus*/
  public NombreTotal: number;
  
  /** duree total des depenses du stage*/
  public totalDepenseStage: number;
  /** boolean pour savoir si on est en mode CURSUS*/
  public IsModeCursus: boolean;

  public isSaving: boolean = false;
  public allTaskAutoSelected: boolean;
  public ReloadAddRow: boolean;

  /** @Output envoyé au parent pour savoir si la liste du stage est vide*/
  @Output() lstIsEmpty = new EventEmitter<boolean>();
  /** @Input recu du parent pour savoir quel stage afficher en fonction de son Ident*/
  @Input() IdentStage: string;
  /** @Input recu du parent pour savoir quel Mode utiliser */
  @Input() Mode: string
  /** sert à lancer le subscribe */
  @Input() Init: Observable<void>
  /** Element detecté pour la modal*/
  @ViewChild('content') content: any;
  /** Element detecté pour la modal*/
  @ViewChild('contentParam') contentParam: any;
  /** Element detecté pour la modal*/
  @ViewChild('contentWorkflow') contentWorkflow: any;
  /** liste des taches*/
  public lstTask: Array<TacheStage>;
  /** liste des taches auto à ajouter à la liste des taches*/
  public lstToCreateAutoTask: Array<TacheStage>;
  /** liste des taches automatiques d'un stage' */
  public lstTaskAuto: Array<TacheStage>;
  public lstTaskParam: Array<TacheParam>;
  public selectedTache: TacheStage;
  /** stock la subscription */
  public observeInit: Subscription;
  public modelBOTache: BObjectModel = new BObjectModel();
  public tacheBo: TacheStage;
  public ModelsDoc: Array<Select> = [];
  public ModelsMail: Array<QueovalDik>;
  

  public modelBODepense: BObjectModel = new BObjectModel();
  
  public tabs: Array<{ Type: number, Font: string, Name: string, Active: boolean, Visible: boolean, Locked: boolean }> = [
    { Active: true, Visible: true, Locked: false, Name: 'Tâche', Type: 0, Font: 'fas fa-book mr-2', },
    { Active: false, Visible: true, Locked: false, Name: 'Dépense', Type: 1, Font: 'fas fa-money-bill mr-2', }
  ];

  // #endregion

  // #region CYCLE DE VIE

  public ngOnInit(): void {
    this.http.getHttp<QResult<ComboProperty>>(`${this.indParam.AppParams.apiUrl}api/Stage/Document/MODELES_DOCUMENT/0`).subscribe
      ((result: QResult<ComboProperty>) => {
        this.ModelsDoc = result.Value.ListProperty;
        this.ModelsDoc.push({ id:'', value: '' });
      })
    this.http.getHttp<SendMailModel>(`${this.indParam.AppParams.apiUrl}api/sendMail/GET_MODELES/STAGE`).subscribe((result: SendMailModel) => {
      this.ModelsMail = result.LstModelesMail;
    });
    this.observeInit = this.Init.subscribe(() => {
      this.OnInit();
    })
    
  }
  //detruit l'observable quand le composant est detruit
  public ngOnDestroy(): void {
    this.observeInit.unsubscribe();
  }
  // #endregion

  // #region FONCTIONS PUBLIQUES

  /** fonction lancé apres le subscribe */
  public OnInit(): void {
    this.ReloadAddRow = false;
    this.taskToAdd = new TacheStage();
    this.oldTask = new TacheStage();
    this.editTask = new TacheStage();
    this.tacheBo = new TacheStage();
    this.hideButton = false;
    this.isDateDebut = true;
    this.isDateFin = true;
    this.totalTempsStage = 0;
    this.totalDepenseStage = 0;
    this.NombreTotal = 0;
    this.IsModeCursus = false;
    this.lstIsEmpty.emit(true);
    this.lstTask = new Array<TacheStage>();
    this.lstToCreateAutoTask = []
    this.lstTaskAuto = [];
    this.lstTaskParam = [];
    this.allTaskAutoSelected = false;

    this.modelBOTache = new BObjectModel();
    this.modelBOTache.IdentBO = "BO_TASK";
    this.modelBOTache.ShowSaveButton = true;

    this.modelBODepense = new BObjectModel();
    this.modelBODepense.IdentBO = "BO_DEPENSE";
    this.modelBODepense.ShowSaveButton = true;

    
    this.InitTaches();
    //l'init change en fonction du mode
    switch (this.Mode) {
      case "MANU":
        break;
      case "PARAM":
        this.InitTachesAutoParam();
        break;
      case "AUTO":
        this.InitTachesAuto();
        break;
      case "CURSUS":
        this.IsModeCursus = true;
        break;
      default:
        break;
    }
  }

  public ActiveTab(indexType: number): void {
    this.tabs.forEach(tab => {
      if (tab.Type === indexType && tab.Visible && !tab.Locked) {
        tab.Active = true;
      }
      else tab.Active = false;
    });
    if (this.tabs.findIndex(t => t.Active) === -1) this.tabs[0].Active = true;
  }


  // Ouverture de la modal pour consulter/update le bo de l'effectif
  public openBoTache(Modal: any, pTache: TacheStage) {
    this.tacheBo = pTache;
    this.modelBOTache.IdDonneeFils = pTache.IdentTache;
    this.modelBODepense.IdDonneeFils = pTache.IdentDepense;
    this.modelBODepense.IdDonneePere = pTache.IdentStage;
    this.modelBODepense.IdRelation = 'REL_BO_STAGE_BO_DEPENSE'
    this.modalService.open(Modal, { centered: true, size: 'q-xxl', windowClass: 'qmodalover' }).result.then((result) => {
      switch (result) {
        case 'SAVE': break;
        case 'CANCEL': break;
      }
    });
  }

  
  public OnSaveBoDepense(pBoModel: BObjectModel) {
    const DepenseTask: BObjectSummary[] = pBoModel.summary.filter((summary: BObjectSummary) => { return summary.ColumnName.toLowerCase() == 'pxvaldep' });
    if (DepenseTask?.length > 0) {
      this.tacheBo.Depense = parseInt(pBoModel.Body.SelectedGroupsList[DepenseTask[0].IndexGroupsList].DataList[DepenseTask[0].IndexDataList].MainElementList[0].Value);
    }
    if (this.tacheBo.IdentDepense == '0') {
      this.tacheBo.IdentDepense = pBoModel.IdDonneeFils;
      let tacheDepense: TacheStage = new TacheStage();
      tacheDepense.IdentTache = this.tacheBo.IdentTache;
      tacheDepense.IdentDepense = this.tacheBo.IdentDepense;      
      this.http.postHttp<QResult<TacheStage>>(`${this.indParam.AppParams.apiUrl}api/Stage/Taches/LINK_TACHE_DEPENSE`, tacheDepense).subscribe(
        (result: QResult<TacheStage>) => {
          if (!result.HasError) {
          }
        });
    }


  }

  public OnSaveBoTache(pBoModel: BObjectModel) {
    const LibelleTask: BObjectSummary[] = pBoModel.summary.filter((summary: BObjectSummary) => { return summary.ColumnName.toLowerCase() == 'objeteve' });
    const DateDebutTask: BObjectSummary[] = pBoModel.summary.filter((summary: BObjectSummary) => { return summary.ColumnName.toLowerCase() == 'datedeve' });
    const DateFinTask: BObjectSummary[] = pBoModel.summary.filter((summary: BObjectSummary) => { return summary.ColumnName.toLowerCase() == 'datefeve' });
    const TempsTask: BObjectSummary[] = pBoModel.summary.filter((summary: BObjectSummary) => { return summary.ColumnName.toLowerCase() == 'dureeeve' });
    //const DepenseTask: BObjectSummary[] = pBoModel.summary.filter((summary: BObjectSummary) => { return summary.ColumnName.toLowerCase() == 'pxvaldep' });
    const CommentaireTask: BObjectSummary[] = pBoModel.summary.filter((summary: BObjectSummary) => { return summary.ColumnName.toLowerCase() == 'info_eve' });
    const EtatTask: BObjectSummary[] = pBoModel.summary.filter((summary: BObjectSummary) => { return summary.ColumnName.toLowerCase() == 'etat_eve' });
    
    if (LibelleTask?.length > 0) {
      this.tacheBo.Libelle = pBoModel.Body.SelectedGroupsList[LibelleTask[0].IndexGroupsList].DataList[LibelleTask[0].IndexDataList].MainElementList[0].Value;
    }

    if (EtatTask?.length > 0) {
      const htmlBase: HtmlBase = pBoModel.Body.SelectedGroupsList[EtatTask[0].IndexGroupsList].DataList[EtatTask[0].IndexDataList].MainElementList[0];
      this.tacheBo.Etat = htmlBase.Value;
      if (htmlBase.SelectOptionsList?.length > 0)
        this.tacheBo.Etat = htmlBase.SelectOptionsList.find(option => option.Selected)?.Value ?? '';
    }

    if (CommentaireTask?.length > 0) {
      this.tacheBo.Commentaire = pBoModel.Body.SelectedGroupsList[CommentaireTask[0].IndexGroupsList].DataList[CommentaireTask[0].IndexDataList].MainElementList[0].Value;
    }
    if (TempsTask?.length > 0) {
      this.tacheBo.Temps = parseInt(pBoModel.Body.SelectedGroupsList[TempsTask[0].IndexGroupsList].DataList[TempsTask[0].IndexDataList].MainElementList[0].Value);
    }
    //if (DepenseTask?.length > 0) {
    //  this.tacheBo.Depense = parseInt(pBoModel.Body.SelectedGroupsList[DepenseTask[0].IndexGroupsList].DataList[DepenseTask[0].IndexDataList].MainElementList[0].Value);
    //}
    if (DateDebutTask?.length > 0) {
      const strDateDebut = pBoModel.Body.SelectedGroupsList[DateDebutTask[0].IndexGroupsList].DataList[DateDebutTask[0].IndexDataList].MainElementList[0].Value.split('/');
      const newDateDebut = new QueovalDate(strDateDebut[2], strDateDebut[1], strDateDebut[0]);
      this.tacheBo.DateDebut = newDateDebut;
    }
    if (DateFinTask?.length > 0) {
      const strDateFin = pBoModel.Body.SelectedGroupsList[DateFinTask[0].IndexGroupsList].DataList[DateFinTask[0].IndexDataList].MainElementList[0].Value.split('/');
      const newDateFin = new QueovalDate(strDateFin[2], strDateFin[1], strDateFin[0]);
      this.tacheBo.DateLimite = newDateFin;
    }
    
  }
  /**
 *  verifie les infos de la tache et lance la creation ou l'update si le model est valide
 *  @param param parametre ('create' | 'update')
 * */
  public VerifyInformations(param: string): void {
    var model: TacheStage = param == "create" ? this.taskToAdd : this.editTask;

    //affectation de l'avatar si non sélectionné
    if (isEmptyStr(model.IdentCollabo) || model.IdentCollabo == "0") {

      if (!isEmptyStr(this.service.Stage.Responsable.Id)) {
        model.IdentCollabo = this.service.Stage.Responsable.Id;
      }
      else if (!isEmptyStr(this.indParam.AppParams.LoggedUser.Ident) && this.indParam.AppParams.LoggedUser.Ident != "0") {
        model.IdentCollabo = this.indParam.AppParams.LoggedUser.Ident;
      }
      else {
        this.toast.showAlertToast("Problème avec l'affectation du collaborateur");
        return;
      }
    }

    const message: Array<string> = new Array<string>();
     //verifie le responsable
    if (!model.IdentCollabo || model.IdentCollabo == '0')
      message.push("responsable");
     //verifie Libelle
    if (!model.Libelle)
      message.push("libellé");
    if (!model.DateDebut || this.qDateService.IsNull(model.DateDebut))
      message.push("date de début");
    if (!model.DateLimite || this.qDateService.IsNull(model.DateLimite))
      message.push("date limite");
    //verification workflow
    if (param == "update") {
      if (model.CreationAutomatique && !model.ModeleDocument)
        message.push("modèle de document obligatoire si creation automatique");
      if (model.ActionAutomatique != '' && model.ModeleEmail == '')
        message.push("sélection modèle email obligatoire pour une action automatique");
      if (model.ActionAutomatique == '' && model.ModeleEmail != '')
        message.push("sélection action automatique obligatoire pour envoyer un email");
      if (model.ModeleDocument != '' && model.ModeleEmail == '' && !model.CreationAutomatique)
        message.push("la selection d'un document implique soit la generation automatique soit la sélection d'un mail");
    }   
    if (message.length > 0) {
      this.toast.showWarningToast(`Veuillez renseigner les champs obligatoires : ${message.join(', ')}`);
      return;
    }
        
    // Verification depense et temps
    if (!model.Depense)
      model.Depense = 0;
    if (!model.Temps)
      model.Temps = 0;

    //verifie que la DateLimite soit supérieur à la DateDebut
    if (this.qDateService.Compare(model.DateDebut, '>', model.DateLimite)) {
      this.toast.showAlertToast('La date de début se trouve après la date de fin');
      return;
    }
    //lance la création ou l'update en fonction du parametre
      if (param == "create") {
        this.CreateTask()
      } else {
        this.UpdateTask()
      }
    

  }

  /**
* permet de supprimer une tache manuelle
* @param tacheToDelete tache a supprimer
*/
  public DeleteTask(tacheToDelete: TacheStage) {
    tacheToDelete.IdentStage = this.IdentStage;
    this.http.postHttp<QResult<TacheStage>>(`${this.indParam.AppParams.apiUrl}api/Stage/Taches/DELETE_TACHE`, tacheToDelete).subscribe(
      (result: QResult<TacheStage>) => {
        if (!result.HasError) {
          if (result.Value.IdentTache == "0") {
            this.lstTask = this.lstTask.filter(x => x.IdentTache != tacheToDelete.IdentTache);
            this.CalculTotal();
            this.toast.showSuccessToast("La tache a été supprimée");
          }

        }
      });
  }

 
  /**
   * Ajoute la tache cochée a la liste des taches à créer
   * @param taskAuto tache auto à ajouter
   */
  public AddAutoTaskInList(taskAuto: TacheStage) {
    taskAuto.IsSelected ? this.lstToCreateAutoTask.push(taskAuto) : this.lstToCreateAutoTask = this.lstToCreateAutoTask.filter(x => x.Libelle != taskAuto.Libelle);
  }
  /**
 * lance la création des taches automatique et ajoute la tache a la liste des taches
 * */
  public CreateAutoTaskWithList() {
    if (this.lstToCreateAutoTask.length == 0) {
      return this.toast.showSuccessToast("Vous n'avez pas sélectionné d'élèments à ajouter");;
    }
    //verifie l'ident du collabo pour l'avatar
    this.lstToCreateAutoTask.forEach(x => {
      if (isEmptyStr(x.IdentCollabo) || x.IdentCollabo == "0") {

        if (!isEmptyStr(this.service.Stage.Responsable.Id) && this.service.Stage.Responsable.Id != "0") {
          x.IdentCollabo = this.service.Stage.Responsable.Id;
        }
        else if (!isEmptyStr(this.indParam.AppParams.LoggedUser.Ident) && this.indParam.AppParams.LoggedUser.Ident != "0") {
          x.IdentCollabo = this.indParam.AppParams.LoggedUser.Ident;
        }
        else {
          this.toast.showAlertToast("Problème avec l'affectation du collaborateur pour les taches automatiques");
        }
      }
      else {
        switch (x.IdentCollabo.toUpperCase()) {
          case "REL_BO_FORMATEUR_BO_STAGE":
            if (this.service.Stage.Formateur != null && this.service.Stage.Formateur.length > 0) {
              x.IdentCollabo = this.service.Stage.Formateur[0].Id;
            }
            else {
              x.IdentCollabo = this.indParam.AppParams.LoggedUser.Ident
              this.toast.showAlertToast("Problème avec l'affectation du formateur");
            }
            break;
          case "REL_RESPONSABLE_BO_STAGE":
            if (this.service.Stage.Responsable != null && !isEmptyStr(this.service.Stage.Responsable.Id) && this.service.Stage.Responsable.Id !== "0") {
              x.IdentCollabo = this.service.Stage.Responsable.Id;
            }
            else {
              x.IdentCollabo = this.indParam.AppParams.LoggedUser.Ident
              this.toast.showAlertToast("Problème avec l'affectation du responsable de stage");
            }
            break;
        }
      }    
    })
    this.http.postHttp<QResult<Array<TacheStage>>>(`${this.indParam.AppParams.apiUrl}api/Stage/Create_Auto_Taches`, this.lstToCreateAutoTask).subscribe(
      (result: QResult<Array<TacheStage>>) => {
        if (!result.HasError) {
          result.Value.forEach(x => this.lstTask.push(x));
          this.CalculTotal();
          this.toast.showSuccessToast("La liste de taches a été mis à jour");
          this.lstToCreateAutoTask = [];
        }
      });
  }
 
  /**
   * permet de modifier l'etat d'une tache au click sur l'icone, ETAT '1' ou '3'
   * ETAT '3' = tache cloturé = icone verte
   * ETAT '1' = tache non cloturé = icone grise
   * @param TaskToUpdate tache selectionné
   */
  public ChangeEtatTask(TaskToUpdate: TacheStage) {
    TaskToUpdate.Etat = TaskToUpdate.Etat == "3" ? "1" : "3";
    this.http.postHttp<QResult<TacheStage>>(`${this.indParam.AppParams.apiUrl}api/Stage/Taches/CHANGE_ETAT_TACHE`, TaskToUpdate).subscribe(
      (result: QResult<TacheStage>) => {
        if (!result.HasError) {
          this.toast.showSuccessToast("L'état de la tache a été modifié");
        }
      });
  }


  /**
   * passe une tache en mode edit pour la modification
   * @param tacheEdit tache à passer en mode edit
   */
  public ActivateModeEdit(tacheEdit: TacheStage) {
    this.oldTask = { ...tacheEdit };
    this.editTask = tacheEdit;
    tacheEdit.ModeEditable = true;
    this.hideButton = true;    
  }

  public ActivateModeEditWorkflow(tacheEdit: TacheStage) {
    this.editTask = tacheEdit;
    this.OpenModal(this.contentWorkflow);
  }



  /**
   * annule le mode edit sur la tache et remet les anciennes valeurs
   * @param tacheCloseEdit tache à fermer
   */
  public CloseModeEdit(tacheCloseEdit: TacheStage) {
    this.oldTask.ModeEditable = false;
 
    tacheCloseEdit.DateDebut = this.oldTask.DateDebut;
    tacheCloseEdit.DateLimite  = this.oldTask.DateLimite;
    tacheCloseEdit.Depense = this.oldTask.Depense;
    tacheCloseEdit.Etat = this.oldTask.Etat;
    tacheCloseEdit.EtatCouleur = this.oldTask.EtatCouleur;
    tacheCloseEdit.IdentCollabo = this.oldTask.IdentCollabo;
    tacheCloseEdit.IdentDepense = this.oldTask.IdentDepense;
    tacheCloseEdit.IdentStage = this.oldTask.IdentStage;
    tacheCloseEdit.IdentTache = this.oldTask.IdentTache;
    tacheCloseEdit.IsSelected = this.oldTask.IsSelected;
    tacheCloseEdit.Libelle = this.oldTask.Libelle;
    tacheCloseEdit.ModeEditable = false;
    tacheCloseEdit.Temps = this.oldTask.Temps;
    tacheCloseEdit.TypeTache = this.oldTask.TypeTache;
    tacheCloseEdit.Commentaire = this.oldTask.Commentaire;

    this.editTask = new TacheStage();
    this.oldTask = new TacheStage();
    this.hideButton = false;
  }
  
  /**
   * Fonction appelée au changement de l'avatar-search
   * @param e event
   * @param param parametre ('create' | 'update')
   */
  public OnCollaboChange(e: any, param: string) {
    var model = param == "create" ? this.taskToAdd : this.editTask;
    if (e.length > 0) {
      if (!isEmptyStr(e[0].Id) && e[0].Id != "0") {
        model.IdentCollabo = e[0].Id
      }
      else {
        this.toast.showAlertToast("Problème avec la sélection du collaborateur");
      }
    }
    else {
      if (this.service.Stage.Responsable.Id) {
        model.IdentCollabo = this.service.Stage.Responsable.Id;
      }
      else {
        model.IdentCollabo = this.indParam.AppParams.LoggedUser.Ident;
        this.toast.showWarningToast("Merci d'affecter un responsable");
      }
    }
    
  }

  /**
  *  Ajoute ou supprime toutes les taches automatiques
  * */
  public AddRemoveAllTaskAuto() {
    if (this.allTaskAutoSelected) {
      this.lstTaskAuto.forEach(x => {
        if (!this.lstToCreateAutoTask.includes(x)) {
          this.lstToCreateAutoTask.push(x)
          x.IsSelected = true;
        }
      })
    } else {
      this.lstTaskAuto.forEach(x => x.IsSelected = false)
      this.lstToCreateAutoTask = [];
    }
  }
  // #endregion

  // #region FONCTIONS PRIVES
  /**
*  charge la liste des taches à afficher
* */
  private InitTaches() {
    this.http.getHttp<QResult<Array<TacheStage>>>(`${this.indParam.AppParams.apiUrl}api/Stage/Taches/INIT_LIST_TACHES/${this.IdentStage}`)
      .subscribe((result: QResult<Array<TacheStage>>) => {
        if (!result.HasError) {
          this.lstTask = result.Value;
          this.lstIsEmpty.emit(this.lstTask.length == 0);
          this.lstTask = this.OrderListByDate(this.lstTask);
          this.CalculTotal();
          
        }
      });
  }
  /**
   *  charge la liste des taches autos et ouvre la modal si des taches auto existent
   * */
  private InitTachesAuto() {
    this.http.getHttp<QResult<Array<TacheStage>>>(`${this.indParam.AppParams.apiUrl}api/Stage/Taches/INIT_LIST_AUTO_TACHES/${this.IdentStage}`)
      .subscribe((result: QResult<Array<TacheStage>>) => {
        if (!result.HasError) {
            this.lstTaskAuto = result.Value;
            this.lstTaskAuto.length > 0 ? this.OpenModal(this.content) : this.toast.showInfoToast("Aucune tache automatique à ajouter");
            if (this.lstTaskAuto.length > 0) {
              this.lstTaskAuto = this.OrderListByDate(this.lstTaskAuto);
            }
        }
      });
  }

  /**
 *  permet de créer une tache manuelle
 * */
  private CreateTask(): void {
    if (this.isSaving) {
      this.toast.showInfoToast('Sauvegarde en cours.');
      return;
    }
    this.isSaving = true;
    this.taskToAdd.IdentStage = this.IdentStage;
    this.http.postHttp<QResult<TacheStage>>(`${this.indParam.AppParams.apiUrl}api/Stage/Taches/CREATE_UPDATE_TACHE`, this.taskToAdd).subscribe(
      (result: QResult<TacheStage>) => {
        this.isSaving = false;
        if (!result.HasError) {
          this.lstTask.push(result.Value);
          this.toast.showSuccessToast("La tâche a été créée");
          this.taskToAdd = new TacheStage();
          this.lstTask = this.OrderListByDate(this.lstTask);
          this.ReloadAddRow = true;
          setTimeout(() => { this.ReloadAddRow = false; },1)
        }
      });
  }


  /**
*  charge la liste de toutes les taches autos
* */
  private InitTachesAutoParam() {
    this.http.getHttp<QResult<Array<TacheParam>>>(`${this.indParam.AppParams.apiUrl}api/Stage/Taches/INIT_LIST_PARAMTACHE/ALL`)
      .subscribe((result: QResult<Array<TacheParam>>) => {
        if (!result.HasError) {
          this.lstTaskParam = result.Value;
          this.OpenModal(this.contentParam);
        }
      });
  }
  /**
*  charge la tache parametre a afficher pour modification
* */
  public SelectTaskParam(pTypeTache: string) {
    this.http.getHttp<QResult<TacheParam>>(`${this.indParam.AppParams.apiUrl}api/Stage/Taches/INIT_PARAMTACHE/${pTypeTache}`)
      .subscribe((result: QResult<TacheParam>) => {
        if (!result.HasError) {
          this.taskParam = result.Value;
        }
      });
  }

  /**
*  permet de créer une tache automatique
* */
  private CreateUpdateTaskParam(): void {
    if (this.isSaving) {
      this.toast.showInfoToast('Sauvegarde en cours.');
      return;
    }
    this.isSaving = true;
    this.http.postHttp<QResult<TacheParam>>(`${this.indParam.AppParams.apiUrl}api/Stage/Taches/CREATE_UPDATE_TACHE_PARAM`, this.taskParam).subscribe(
      (result: QResult<TacheParam>) => {
        this.isSaving = false;
        if (!result.HasError) {
          if (this.taskParam.Ident == '0') {
            this.lstTaskParam.push(result.Value);
          }
          this.toast.showSuccessToast("La tâche a été créée");
          this.taskParam = new TacheParam();
        }
      });
  }
  public DeleteTaskParam() {
    this.http.postHttp<QResult<TacheParam>>(`${this.indParam.AppParams.apiUrl}api/Stage/Taches/DELETE_TACHE_PARAM`, this.taskParam).subscribe(
      (result: QResult<TacheParam>) => {
        if (!result.HasError) {
          if (result.Value.Ident == "0") {
            this.lstTaskParam.splice(this.lstTaskParam.findIndex(x => x.Ident == this.taskParam.Ident), 1);
            this.InitTaskParam()
            this.toast.showSuccessToast("La tache automatique a été supprimée");
          }
        }
      });
  }

  public InitTaskParam(): void {
    this.taskParam = new TacheParam();
  }
  public VerifyTaskParam(param: string): void {

    const message: Array<string> = new Array<string>();

    //verification de la presence de l'intitullé
    if (!this.taskParam.Intitule)
      message.push("Intitullé");
    //verification de la presence d'une date de réference
    if (!this.taskParam.DateReference)
      message.push("Date de référence");
    if (this.taskParam.CreationAutomatique && !this.taskParam.ModeleDocument)
      message.push("modèle de document obligatoire si creation automatique");
    if (this.taskParam.ActionAutomatique != '' && this.taskParam.ModeleEmail == '')
      message.push("sélection modèle email obligatoire pour une action automatique");
    if (this.taskParam.ActionAutomatique == '' && this.taskParam.ModeleEmail != '')
      message.push("sélection action automatique obligatoire pour envoyer un email");
    if (this.taskParam.ModeleDocument != '' && this.taskParam.ModeleEmail == '' && !this.taskParam.CreationAutomatique)
      message.push("la selection d'un document implique soit la generation automatique soit la selection d'un mail");
    if (message.length > 0) {
      this.toast.showWarningToast(`Veuillez corriger les erreurs: ${message.join(', ')}`);
      return;
    }

    // Verification depense et temps
    if (!this.taskParam.Depense)
      this.taskParam.Depense = 0;
    if (!this.taskParam.Temps)
      this.taskParam.Temps = 0;

    //lance la création ou l'update en fonction du parametre
    this.CreateUpdateTaskParam()
  }


  /**
 *  permet de modifier une tache manuelle
 * */
  private UpdateTask() {
    this.editTask.IdentStage = this.IdentStage;
    this.http.postHttp<QResult<TacheStage>>(`${this.indParam.AppParams.apiUrl}api/Stage/Taches/CREATE_UPDATE_TACHE`, this.editTask).subscribe(
      (result: QResult<TacheStage>) => {
        if (!result.HasError) {
          for (var i = 0; i < this.lstTask.length; i++) {
            if (this.editTask.IdentTache == this.lstTask[i].IdentTache) {
              this.lstTask[i] = result.Value;
              this.lstTask[i].ModeEditable = false;
              this.CalculTotal();

            }
          }
          this.lstTask = this.OrderListByDate(this.lstTask);
          this.hideButton = false;
          this.editTask = new TacheStage();
          this.toast.showSuccessToast("La tache a été modifiée");
        }
      });
  }

  /**
   * ouvre la modal pour le mode auto
   * @param content element html à cibler
   */
  private OpenModal(content: any) {
    this.modalService.open(content, { centered: true, windowClass:'qmodalover', scrollable: true, ariaLabelledBy: 'modal-basic-title', size: 'q-xxl' });
  }

  public OpenDelete(Modal: any, tache: TacheStage ) {
    this.selectedTache = tache;
    this.modalService.open(Modal, { centered: true, windowClass: 'qmodalover' });
  }

  /**
   * calcul le total des depenses et des temps d'un stage
   * */
  private CalculTotal() {
    this.NombreTotal = 0;
    this.totalTempsStage = 0;
    this.totalDepenseStage = 0;
    this.lstTask.forEach(x => {
      if (Number(x.Temps) > 0) {
        this.totalTempsStage += Number(x.Temps)
      }
      if (Number(x.Depense) > 0) {
        this.totalDepenseStage += Number(x.Depense)
      }
      this.NombreTotal = this.NombreTotal + 1;
    })
  }

  /**
   * retourne une liste trié par date 
   * (de la plus vieille date à la plus récente)
   * @param lstToOrder liste à trier
   */
  private OrderListByDate(lstToOrder: TacheStage[]): TacheStage[] {
    return lstToOrder.sort((objA, objB) => Number(this.qDateService.ToDate(objA.DateDebut)) - Number(this.qDateService.ToDate(objB.DateDebut)))
  }

  // #endregion
}

@Pipe({
  name: 'avatarSearchValue'
})
export class AvatarSearchValue implements PipeTransform {

  constructor(
  ) { }
  /**
   * 
   * @param value sert à rafraichir le display lorsque la valeur change (ne sert pas dans l'algo)
   * @param property
   * @param type
   */
  transform(value: string): Array<string> {
    return value ? [value] : [];
  }
}

